/*
  ============================================================
  KETTING ERBIJ? — kettingkeuze op de productpagina — Mónós
  Bestandsnaam: assets/ketting-keuze.js
  Hoort bij:    snippets/ketting-keuze.liquid

  - Toont de kettingen in het materiaal van de gekozen steen en
    wisselt mee als de klant een andere steen kiest.
  - Zet 'Zonder ketting' alvast aan voor wie er al een heeft
    (in het mandje, eerder gekocht, of eerder zo gekozen).
  - Na 'In winkelmandje': eerst gaat de hanger erin (zoals altijd),
    daarna voegt dit script de gekozen ketting toe en vult het
    popupje aan. Lukt de hanger niet, dan komt er ook geen ketting.
  ============================================================
*/
(function () {
  'use strict';

  if (window.monosKettingKeuze) {
    window.monosKettingKeuze.start(document);
    return;
  }

  var OPSLAG = 'monosKettingKeuze';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var instanties = [];

  /* ---------- Hulpjes ---------- */

  var WOORDEN = {
    filled: ['filled', 'gefüllt', 'gefuellt', 'gefullt', 'gevuld', 'doublé', 'golddoubl', 'vergold', 'verguld', 'plated'],
    zilver: ['sterling', 'silver', 'silber', 'zilver', '925'],
    k14: ['karaat', 'karat', 'carat', '14k', '14 k', '14ct', '14 ct', '585', 'gold', 'goud']
  };

  function bevat(tekst, lijst) {
    for (var i = 0; i < lijst.length; i++) {
      if (tekst.indexOf(lijst[i]) !== -1) return true;
    }
    return false;
  }

  function metaalVan(tekst) {
    var t = String(tekst || '').toLowerCase();
    if (bevat(t, WOORDEN.filled)) return 'filled';
    if (bevat(t, WOORDEN.zilver)) return 'zilver';
    if (bevat(t, WOORDEN.k14)) return '14k';
    return '';
  }

  function familie(metaal) {
    if (!metaal) return '';
    return metaal === 'zilver' ? 'zilver' : 'goud';
  }

  function leesGeheugen() {
    try {
      var g = JSON.parse(window.localStorage.getItem(OPSLAG) || '{}');
      return g && typeof g === 'object' ? g : {};
    } catch (e) {
      return {};
    }
  }

  function schrijfGeheugen(g) {
    try {
      window.localStorage.setItem(OPSLAG, JSON.stringify(g));
    } catch (e) { /* privévenster of geblokkeerd: dan onthouden we niets */ }
  }

  function jq() {
    return (window.theme && window.theme.jQuery) || window.jQuery || null;
  }

  function koers() {
    var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  /* ---------- Eén blok ---------- */

  function KettingKeuze(el) {
    this.el = el;
    var dataEl = el.querySelector('[data-kk-data]');
    try {
      this.data = JSON.parse(dataEl.textContent);
    } catch (e) {
      this.data = null;
      return;
    }

    this.form = document.getElementById(this.data.formId);
    this.area = el.closest('.product-area') || document;
    this.metaal = this.data.metaal || 'zilver';
    this.prijsHanger = Number(this.data.prijsHanger) || 0;
    this.mandjeTotaal = Number(this.data.mandjeTotaal) || 0;
    this.mandje = this.data.mandje || {};
    this.eigen = this.data.eigen || {};
    this.T = this.data.teksten || {};
    this.onthouden = !!this.data.onthouden;
    this.geheugen = this.onthouden ? leesGeheugen() : {};
    this.geheugen.heeft = this.geheugen.heeft || {};
    this.geheugen.soort = this.geheugen.soort || {};

    this.keuze = null;        // 'met', 'zonder' of null
    this.automatisch = false; // keuze door ons gezet, niet door de klant
    this.handmatig = false;   // klant heeft zelf gekozen op deze pagina
    this.bezig = null;        // ketting die na de hanger nog in het mandje moet

    this.keuzeInputs = el.querySelectorAll('[data-kk-keuze]');
    this.opties = el.querySelector('[data-kk-opties]');
    this.optiesBinnen = el.querySelector('[data-kk-opties-binnen]');
    this.prijsEl = el.querySelector('[data-kk-prijs]');
    this.samenvattingEl = el.querySelector('[data-kk-samenvatting]');
    this.meldingEl = el.querySelector('[data-kk-melding]');
    this.gratisEl = el.querySelector('[data-kk-gratis]');
    this.foutEl = el.querySelector('[data-kk-fout]');
    this.venster = el.querySelector('[data-kk-venster]');
    this.vensterInhoud = el.querySelector('[data-kk-venster-inhoud]');

    this.bind();
    this.bindVenster();
    this.pasVoorkeurToe();
    this.update();
    el.setAttribute('data-kk-klaar', '');
  }

  KettingKeuze.prototype.groep = function () {
    return this.el.querySelector('[data-kk-groep="' + this.metaal + '"]');
  };

  KettingKeuze.prototype.bind = function () {
    var self = this;

    Array.prototype.forEach.call(this.keuzeInputs, function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        self.handmatig = true;
        self.automatisch = false;
        self.keuze = input.value;
        self.verbergFout();
        if (input.value === 'zonder') self.onthoud('heeft', familie(self.metaal), true);
        self.update();
      });
    });

    this.el.addEventListener('change', function (evt) {
      var t = evt.target;
      if (t.hasAttribute('data-kk-soort')) {
        self.onthoud('soort', self.metaal, t.value);
        self.update();
      } else if (t.hasAttribute('data-kk-lengte')) {
        self.onthoud('lengte', null, t.getAttribute('data-lengte'));
        self.update();
      }
    });

    // Alleen het vergrootglas opent het venster. Een tik op de kaart (ook op de foto) kiest alleen.
    this.el.addEventListener('click', function (evt) {
      if (!evt.target.closest) return;
      var glas = evt.target.closest('[data-kk-vergroot]');
      if (glas && self.el.contains(glas)) {
        evt.preventDefault();
        self.openVenster(glas.getAttribute('data-kk-vergroot'));
      }
    });

    // Kies je een soort ketting terwijl 'Met ketting' nog niet aan staat? Dan zetten we hem aan.
    this.el.addEventListener('click', function (evt) {
      if (evt.target.closest && evt.target.closest('.kk__kaart, .kk__chip')) {
        var met = self.el.querySelector('[data-kk-keuze][value="met"]');
        if (met && !met.checked) {
          met.checked = true;
          met.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    document.addEventListener('on:variant:change', function (evt) {
      if (!self.el.isConnected) return;
      if (self.area !== document && evt.target && !self.area.contains(evt.target)) return;
      var v = evt.detail && evt.detail.variant;
      if (!v) return;
      var tekst = [v.title, v.public_title, (v.options || []).join(' ')].join(' ');
      var nieuw = metaalVan(tekst) || 'zilver';
      self.prijsHanger = Number(v.price) || self.prijsHanger;
      if (nieuw !== self.metaal) {
        self.metaal = nieuw;
        if (!self.handmatig) self.pasVoorkeurToe();
      }
      self.update();
    });
  };

  /* ---------- Ketting groot bekijken ---------- */

  KettingKeuze.prototype.bindVenster = function () {
    var self = this;
    var v = this.venster;
    if (!v) return;

    v.addEventListener('click', function (evt) {
      if (evt.target === v || (evt.target.closest && evt.target.closest('[data-kk-sluit]'))) {
        v.close();
        return;
      }
      var kies = evt.target.closest && evt.target.closest('[data-kk-kies]');
      if (kies) {
        self.kiesSoort(kies.getAttribute('data-kk-kies'));
        v.close();
        return;
      }
      var stip = evt.target.closest && evt.target.closest('[data-kk-stip]');
      if (stip) {
        var fotos = v.querySelector('[data-kk-fotos]');
        if (fotos) fotos.scrollTo({ left: Number(stip.getAttribute('data-kk-stip')) * fotos.clientWidth, behavior: 'smooth' });
      }
    });

    v.addEventListener('close', function () {
      document.documentElement.classList.remove('kk-venster-open');
    });
  };

  KettingKeuze.prototype.openVenster = function (handle) {
    var tpl = this.el.querySelector('template[data-kk-detail="' + CSS.escape(handle) + '"]');
    if (!tpl) return;
    var v = this.venster;

    // Geen venster mogelijk (heel oude browser): productpagina in een nieuw tabblad.
    if (!v || typeof v.showModal !== 'function') {
      var a = tpl.content.querySelector('a[href]');
      if (a) window.open(a.href, '_blank', 'noopener');
      return;
    }

    this.vensterInhoud.innerHTML = '';
    this.vensterInhoud.appendChild(tpl.content.cloneNode(true));

    var fotos = this.vensterInhoud.querySelector('[data-kk-fotos]');
    var stippen = this.vensterInhoud.querySelectorAll('[data-kk-stip]');
    if (fotos && stippen.length) {
      var markeer = function () {
        var i = Math.round(fotos.scrollLeft / Math.max(1, fotos.clientWidth));
        Array.prototype.forEach.call(stippen, function (s, j) { s.classList.toggle('is-actief', i === j); });
      };
      var wacht = null;
      fotos.addEventListener('scroll', function () {
        if (wacht) cancelAnimationFrame(wacht);
        wacht = requestAnimationFrame(markeer);
      }, { passive: true });
      markeer();
    }

    if (!v.open) v.showModal();
    document.documentElement.classList.add('kk-venster-open');
  };

  KettingKeuze.prototype.kiesSoort = function (handle) {
    var groep = this.groep();
    var input = groep && groep.querySelector('[data-kk-soort][value="' + CSS.escape(handle) + '"]');
    if (input) {
      input.checked = true;
      this.onthoud('soort', this.metaal, handle);
    }
    this.handmatig = true;
    this.automatisch = false;
    this.zetKeuze('met');
    this.verbergFout();
    this.update();
  };

  KettingKeuze.prototype.onthoud = function (soort, sleutel, waarde) {
    if (!this.onthouden) return;
    if (soort === 'lengte') {
      this.geheugen.lengte = waarde;
    } else if (sleutel) {
      this.geheugen[soort][sleutel] = waarde;
    }
    schrijfGeheugen(this.geheugen);
  };

  // Wie al een ketting heeft in deze kleur, krijgt 'Zonder ketting' alvast aangevinkt.
  KettingKeuze.prototype.pasVoorkeurToe = function () {
    var fam = familie(this.metaal);
    var ander = fam === 'zilver' ? 'goud' : 'zilver';
    var melding = '';
    var zonder = false;

    if (this.mandje[fam]) {
      melding = this.T.mandje;
      zonder = true;
    } else if (this.eigen[fam]) {
      melding = fam === 'zilver' ? this.T.eerderZilverZelfde : this.T.eerderGoudZelfde;
      zonder = true;
    } else if (this.eigen[ander]) {
      melding = ander === 'zilver' ? this.T.eerderZilverAnder : this.T.eerderGoudAnder;
    } else if (this.geheugen.heeft[fam]) {
      zonder = true;
    }

    this.zetMelding(melding);

    if (zonder) {
      this.zetKeuze('zonder');
      this.automatisch = true;
    } else if (this.automatisch) {
      this.zetKeuze(null);
      this.automatisch = false;
    }
  };

  KettingKeuze.prototype.zetKeuze = function (waarde) {
    this.keuze = waarde;
    Array.prototype.forEach.call(this.keuzeInputs, function (input) {
      input.checked = input.value === waarde;
    });
  };

  KettingKeuze.prototype.zetMelding = function (tekst) {
    if (!this.meldingEl) return;
    this.meldingEl.textContent = tekst || '';
    this.meldingEl.hidden = !tekst;
  };

  // Zorgt dat er in de zichtbare groep altijd een soort en een lengte gekozen is.
  KettingKeuze.prototype.selectie = function () {
    var groep = this.groep();
    if (!groep) return null;

    var soorten = groep.querySelectorAll('[data-kk-soort]');
    if (!soorten.length) return null;
    var soort = groep.querySelector('[data-kk-soort]:checked');
    if (!soort) {
      var onthouden = this.geheugen.soort[this.metaal];
      soort = (onthouden && groep.querySelector('[data-kk-soort][value="' + CSS.escape(onthouden) + '"]')) || soorten[0];
      soort.checked = true;
    }

    var lengtesEl = groep.querySelector('[data-kk-lengtes="' + CSS.escape(soort.value) + '"]');
    Array.prototype.forEach.call(groep.querySelectorAll('[data-kk-lengtes]'), function (f) {
      f.hidden = f !== lengtesEl;
    });
    if (!lengtesEl) return null;

    var lengte = lengtesEl.querySelector('[data-kk-lengte]:checked:not(:disabled)');
    if (!lengte) {
      var vrij = lengtesEl.querySelectorAll('[data-kk-lengte]:not(:disabled)');
      if (!vrij.length) return null;
      var bewaard = this.geheugen.lengte;
      var kandidaat = null;
      if (bewaard) {
        Array.prototype.forEach.call(vrij, function (i) {
          if (!kandidaat && i.getAttribute('data-lengte') === bewaard) kandidaat = i;
        });
      }
      lengte = kandidaat || lengtesEl.querySelector('[data-kk-lengte][data-standaard]:not(:disabled)') || vrij[0];
      lengte.checked = true;
    }

    var stukken = [soort.getAttribute('data-naam')];
    if (soort.getAttribute('data-metaal-label')) stukken.push(soort.getAttribute('data-metaal-label'));
    stukken.push(lengte.getAttribute('data-lengte'));

    return {
      id: lengte.value,
      prijs: Number(lengte.getAttribute('data-prijs')) || 0,
      prijsTekst: lengte.getAttribute('data-prijs-tekst') || '',
      label: stukken.join(', ')
    };
  };

  KettingKeuze.prototype.update = function () {
    var self = this;
    var groep = this.groep();

    // Geen kettingen voor dit materiaal: blok weg.
    this.el.hidden = !groep;
    this.toonLosMelding(!groep);
    if (!groep) return;

    Array.prototype.forEach.call(this.el.querySelectorAll('[data-kk-groep]'), function (g) {
      g.hidden = g !== groep;
    });

    var sel = this.selectie();
    this.huidige = sel;

    if (this.prijsEl) this.prijsEl.textContent = sel ? '+ ' + sel.prijsTekst : '';
    if (this.samenvattingEl) this.samenvattingEl.textContent = sel ? sel.label : '';

    Array.prototype.forEach.call(this.el.querySelectorAll('[data-kk-keuze-label]'), function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-gekozen', !!(input && input.checked));
    });

    var open = this.keuze === 'met';
    if (this.opties) this.opties.classList.toggle('is-open', open);
    if (this.optiesBinnen) {
      if (open) this.optiesBinnen.removeAttribute('inert');
      else this.optiesBinnen.setAttribute('inert', '');
    }

    // Gratis verzending: alleen tonen als de ketting de bestelling over de grens tilt.
    if (this.gratisEl) {
      var g = this.data.gratis || {};
      var toon = false;
      if (g.aan && g.landOk && sel && this.keuze !== 'zonder' && Number(g.drempel) > 0) {
        var drempel = Math.round(Number(g.drempel) * 100 * koers());
        var basis = this.mandjeTotaal + this.prijsHanger;
        toon = basis < drempel && basis + sel.prijs >= drempel;
      }
      this.gratisEl.hidden = !toon;
    }
  };

  // Oude melding 'halskettingen zijn los verkrijgbaar' verbergen zolang dit blok zichtbaar is.
  KettingKeuze.prototype.toonLosMelding = function (tonen) {
    if (!this.data.verbergLosMelding) return;
    Array.prototype.forEach.call(this.area.querySelectorAll('.monos-los-verkrijgbaar'), function (n) {
      n.style.display = tonen ? '' : 'none';
    });
  };

  KettingKeuze.prototype.verbergFout = function () {
    if (this.foutEl) this.foutEl.hidden = true;
  };

  KettingKeuze.prototype.toonFout = function () {
    if (!this.foutEl) return;
    this.foutEl.textContent = this.T.fout || '';
    this.foutEl.hidden = false;
  };

  /* ---------- In winkelmandje ---------- */

  KettingKeuze.prototype.bijVersturen = function (evt) {
    if (!this.form || evt.target !== this.form) return;
    this.bezig = null;
    if (this.el.hidden || this.keuze !== 'met' || !this.huidige) return;

    var idVeld = this.form.querySelector('[name="id"]');
    this.bezig = {
      id: this.huidige.id,
      label: this.huidige.label,
      familie: familie(this.metaal),
      hanger: idVeld ? String(idVeld.value) : '',
      tijd: Date.now()
    };

    // Zonder ajax (instelling 'naar winkelmandje'): eerst de ketting, dan het formulier versturen.
    var pf = this.form.closest('product-form');
    var ajax = pf && pf.getAttribute('data-ajax-add-to-cart') === 'true' && !this.form.classList.contains('feedback-go_to_cart');
    if (!ajax) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var form = this.form;
      this.voegKettingToe().then(function () {
        HTMLFormElement.prototype.submit.call(form);
      });
    }
  };

  KettingKeuze.prototype.naHanger = function (instellingen, gelukt) {
    var b = this.bezig;
    if (!b) return;
    if (Date.now() - b.tijd > 30000) { this.bezig = null; return; }
    var data = instellingen && instellingen.data;
    if (typeof data === 'string' && b.hanger && data.indexOf('id=' + b.hanger) === -1) return;
    if (!gelukt) { this.bezig = null; return; }
    this.voegKettingToe();
  };

  KettingKeuze.prototype.voegKettingToe = function () {
    var self = this;
    var b = this.bezig;
    this.bezig = null;
    if (!b) return Promise.resolve();

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.id), quantity: 1, properties: { _kettingkeuze: '1' } }] })
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function () {
        self.mandje[b.familie] = true;
        self.onthoud('heeft', b.familie, true);
        self.zetPopupRegel((self.T.toegevoegd || '+ [ketting]').replace('[ketting]', b.label), false);
        self.verversKop();
        self.verversTotaal();
        self.handmatig = false;
        self.pasVoorkeurToe();
        self.update();
        document.dispatchEvent(new CustomEvent('monos:ketting:toegevoegd', { detail: { variantId: Number(b.id), label: b.label } }));
      })
      .catch(function () {
        self.toonFout();
        self.zetPopupRegel(self.T.fout || '', true);
      });
  };

  // Een regel onder de hanger in de 'toegevoegd'-popup van het thema.
  KettingKeuze.prototype.zetPopupRegel = function (tekst, fout) {
    if (!tekst) return;
    var pogingen = 0;
    (function zoek() {
      var plek = document.querySelector('#added-to-cart .cart-product__content');
      if (!plek) {
        if (++pogingen < 25) setTimeout(zoek, 120);
        return;
      }
      var oud = plek.querySelector('.kk-popup-regel');
      if (oud) oud.remove();
      var p = document.createElement('p');
      p.className = 'cart-product__content__meta kk-popup-regel';
      if (fout) p.style.color = '#A4513D';
      p.textContent = tekst;
      plek.appendChild(p);
    })();
  };

  // Aantal in de kop verversen, net zoals het thema dat doet.
  KettingKeuze.prototype.verversKop = function () {
    var $ = jq();
    if (!$ || !window.theme || !theme.routes) return;
    $.get(theme.routes.cart_url, function (data) {
      var selector = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
      var $nieuw = $($.parseHTML('<div>' + data + '</div>')).find(selector);
      $(selector).each(function (i) {
        if (!$nieuw[i]) return;
        $($nieuw[i]).find('[data-cc-animate]').removeAttr('data-cc-animate');
        $(this).replaceWith($nieuw[i]);
      });
    });
  };

  KettingKeuze.prototype.verversTotaal = function () {
    var self = this;
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        self.mandjeTotaal = Number(cart.total_price) || 0;
        self.update();
      })
      .catch(function () {});
  };

  /* ---------- Opstarten ---------- */

  function start(scope) {
    (scope || document).querySelectorAll('[data-kk]:not([data-kk-klaar])').forEach(function (el) {
      var k = new KettingKeuze(el);
      if (k.data) instanties.push(k);
    });
  }

  // Vóór het thema meeluisteren op 'In winkelmandje' (vangfase op document).
  document.addEventListener('submit', function (evt) {
    instanties.forEach(function (k) { k.bijVersturen(evt); });
  }, true);

  var gekoppeld = false;
  function koppelJQuery() {
    var $ = jq();
    if (gekoppeld || !$) return;
    gekoppeld = true;
    $(document).on('ajaxSuccess.kettingkeuze', function (e, xhr, s) {
      if (!s || !/\/cart\/add(\.js)?(\?|$)/.test(s.url || '')) return;
      instanties.forEach(function (k) {
        if (k.bezig) k.naHanger(s, true);
        else k.verversTotaal();
      });
    });
    $(document).on('ajaxError.kettingkeuze', function (e, xhr, s) {
      if (!s || !/\/cart\/add(\.js)?(\?|$)/.test(s.url || '')) return;
      instanties.forEach(function (k) { k.naHanger(s, false); });
    });
  }

  window.monosKettingKeuze = { start: start };

  start(document);
  koppelJQuery();
  document.addEventListener('DOMContentLoaded', function () { start(document); koppelJQuery(); });
  window.addEventListener('load', koppelJQuery);

  // Themabewerker
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target && e.target.matches && e.target.matches('[data-kk]') ? e.target : null;
    if (!el) return;
    instanties.forEach(function (k) {
      if (k.el === el) {
        k.zetKeuze('met');
        k.update();
      }
    });
  });
})();
